import api from '../../../api';

// Send project email to client with attachment
export const sendProjectEmail = async (emailData) => {
  try {
    console.log('=== DEBUG: API Send Email ===');
    console.log('Email data to send:', emailData);
    
    // Gunakan endpoint yang sudah ada
    const response = await api.post('/crm/projects/send-email', emailData);
    console.log('Email API response:', response);
    
    return response.data;
  } catch (error) {
    console.error('Error sending project email:', error);
    throw error;
  }
};

// Get project email templates
export const getProjectEmailTemplates = async () => {
  try {
    console.log('=== DEBUG: API Get Templates ===');
    
    const response = await api.get('/email/templates/template-id/project');
    console.log('Raw API response for templates:', response);
    
    // Handle different response formats
    let templates = [];
    if (response.data) {
      if (Array.isArray(response.data)) {
        templates = response.data;
      } else if (response.data.content && Array.isArray(response.data.content)) {
        templates = response.data.content;
      } else if (typeof response.data === 'object') {
        // Single template object - wrap in array
        templates = [response.data];
      }
    }
    
    console.log('Processed templates:', templates);
    console.log('=== END DEBUG: API Get Templates ===');
    return templates;
  } catch (error) {
    console.error('Error fetching project email templates:', error);
    // Return empty array if no templates found
    return [];
  }
};

// Check email settings
export const checkEmailSettings = async () => {
  try {
    console.log('=== DEBUG: API Check Email Settings ===');
    
    const response = await api.get('/email/settings');
    console.log('Email settings API response:', response);
    
    console.log('=== END DEBUG: API Check Email Settings ===');
    return response.data;
  } catch (error) {
    console.error('Error checking email settings:', error);
    return null;
  }
}; 